import { render, staticRenderFns } from "./weaponTabCard.vue?vue&type=template&id=634af481&scoped=true"
import script from "./weaponTabCard.vue?vue&type=script&lang=js"
export * from "./weaponTabCard.vue?vue&type=script&lang=js"
import style0 from "./weaponTabCard.vue?vue&type=style&index=0&id=634af481&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634af481",
  null
  
)

export default component.exports